import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=c82feffc&scoped=true"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"
import style0 from "./MessagePage.vue?vue&type=style&index=0&id=c82feffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82feffc",
  null
  
)

export default component.exports